import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KycVersionsService } from '@common/services/kyc-versions.service';
import { DashboardService } from '@pages/dashboard/dashboard.service';
import { firstValueFrom, filter } from 'rxjs';

export const kycVersionsGuard: CanActivateFn = async () => {
  const _KycVersionsService = inject(KycVersionsService);
  const _DashboardService: DashboardService = inject(DashboardService);

  await firstValueFrom(_DashboardService.fetchInvestorProfileData());

  await firstValueFrom(
    _DashboardService.investorProfile.pipe(
      filter(profile => profile !== undefined)
    )
  );

  return firstValueFrom(_KycVersionsService.checkKycVersionsNavigation());
};
